"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlockModel = void 0;
var CleanJson_1 = __importDefault(require("CleanJson/CleanJson"));
var lodash_1 = require("lodash");
var Text = require("./Text");
var Quote = require("./Quote");
var Video = require("./Video");
var Splash = require("./Splash");
var Source = require("./Source");
var Accept = require("./Accept");
var QuoteV2 = require("./QuoteV2");
var Agreement = require("./Agreement");
var blockModels = {
    Text: Text,
    Quote: Quote,
    Video: Video,
    Splash: Splash,
    Source: Source,
    Accept: Accept,
    QuoteV2: QuoteV2,
    Agreement: Agreement,
};
var getBlockModel = function (blockType, preset) {
    var blockModel = blockModels[blockType];
    if (!blockModel.type) {
        blockModel = blockModel[preset !== null && preset !== void 0 ? preset : "default"];
    }
    return (0, CleanJson_1.default)((0, lodash_1.cloneDeep)(blockModel));
};
exports.getBlockModel = getBlockModel;
